<template>
  <div v-if="!loading" class="flex-1 px-4 lg:ml-6">
    <h5 class="text-sm font-medium text-gray-600 mb-2">
      Stage
      <span v-if="pipeline" class="hidden lg:inline">
        &bull;
        <RouterLink
          :to="{
            name: 'accounts.pipelines.pipelineUuid',
            params: {
              accountId: contactRequest.accountId,
              pipelineUuid: pipeline.id,
            },
          }"
          class="text-blue-700"
        >
          Open Pipeline
        </RouterLink>
      </span>
      <EnterPipeline :contact-request="contactRequest" @change="fetchPipelineStage" />
    </h5>
    <Pipeline
      v-if="pipelineStage"
      :contact-request-id="contactRequest.id"
      :pipeline-stage="pipelineStage"
    />
    <div v-else class="flex-none py-1 text-gray-900 leading-6 truncate">No Pipeline</div>
  </div>
</template>

<script>
import EnterPipeline from './EnterPipeline.vue';
import Pipeline from './Pipeline.vue';

export default {
  components: {
    EnterPipeline,
    Pipeline,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    pipelineStage() {
      return this.$store.getters['ui/contactRequestPipelineStage/itemByParent'](
        this.contactRequest.id
      );
    },
    pipeline() {
      if (!this.pipelineStage) {
        return null;
      }

      return this.$store.state.entities.pipelines.byId[this.pipelineStage.pipelineId] || null;
    },
  },
  created() {
    this.fetchPipelineStage();
  },
  methods: {
    async fetchPipelineStage() {
      try {
        this.loading = true;

        await this.$store.dispatch('ui/contactRequestPipelineStage/read', {
          id: this.contactRequest.id,
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
